'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _lib = require('react-chartjs-2/lib');

var _constants = require('../../constants');

var _utils = require('../../utils');

var _common = require('../common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var CASE_CLOSED_STATUSES = _constants.AppConstants.CASE_CLOSED_STATUSES,
    CHART_COLORS = _constants.AppConstants.CHART_COLORS;
var formatMoney = _utils.FormattingUtils.formatMoney,
    formatPercentage = _utils.FormattingUtils.formatPercentage,
    getNameOrDefault = _utils.FormattingUtils.getNameOrDefault;


var CHART_OPTIONS = {
  animation: {
    animateRotate: true,
    animateScale: true
  },
  cutoutPercentage: 85
},
    LEGEND_OPTIONS = {
  labels: {
    fontColor: '#2f3535',
    fontFamily: 'Open Sans',
    fontSize: 11,
    fontStyle: 'bold',
    padding: 15,
    usePointStyle: true
  },
  onClick: false,
  position: 'right'
};

var PerformanceAnalytics = (_dec = (0, _mobxReact.inject)('PartyStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(PerformanceAnalytics, _Component);

  function PerformanceAnalytics() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PerformanceAnalytics);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PerformanceAnalytics.__proto__ || Object.getPrototypeOf(PerformanceAnalytics)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'isLoading', _descriptor, _this), _initDefineProp(_this, 'analytics', _descriptor2, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PerformanceAnalytics, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setInitialState();
    }
  }, {
    key: 'setInitialState',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _props, contact, PartyStore;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.isLoading = true;
                _props = this.props, contact = _props.contact, PartyStore = _props.PartyStore;

                if (!contact) {
                  _context.next = 6;
                  break;
                }

                _context.next = 5;
                return PartyStore.fetchPerformanceAnalytics(contact.id);

              case 5:
                this.analytics = _context.sent;

              case 6:

                this.isLoading = false;

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setInitialState() {
        return _ref2.apply(this, arguments);
      }

      return setInitialState;
    }()
  }, {
    key: 'renderEmptyAnalytics',
    value: function renderEmptyAnalytics() {
      if (this.isLoading) {
        return _react2.default.createElement(_common.Loader, { className: 'page-loader' });
      }

      return _react2.default.createElement(
        'p',
        { className: 'text-muted' },
        'Analytics for ',
        _react2.default.createElement(
          'b',
          null,
          getNameOrDefault(this.props.contact)
        ),
        ' will be available once a lien has been logged as returned'
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'section-stats' },
        _react2.default.createElement(
          'h3',
          null,
          'Returned Cases'
        ),
        this.analytics ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
              _Col2.default,
              { xs: 4 },
              _react2.default.createElement(
                'h4',
                null,
                'Gross Profit'
              ),
              _react2.default.createElement(
                'div',
                { className: 'big' },
                formatMoney(this.analytics.gross_profit)
              )
            ),
            _react2.default.createElement(
              _Col2.default,
              { xs: 4 },
              _react2.default.createElement(
                'h4',
                null,
                'Simple ROI'
              ),
              _react2.default.createElement(
                'div',
                { className: 'big' },
                formatPercentage(this.analytics.simple_roi)
              )
            )
          ),
          _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
              _Col2.default,
              { className: 'chart' },
              _react2.default.createElement(_lib.Doughnut, {
                data: this.returnedCasesChartData,
                legend: LEGEND_OPTIONS,
                options: CHART_OPTIONS
              })
            )
          )
        ) : this.renderEmptyAnalytics()
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'returnedCasesChartData',
    get: function get() {
      var _this2 = this;

      var usedStatuses = Object.keys(CASE_CLOSED_STATUSES).filter(function (status) {
        return _this2.analytics[status] !== null;
      }),
          statusLabels = usedStatuses.map(function (status) {
        var formattedStatus = CASE_CLOSED_STATUSES[status].toLowerCase().split('closed - ').pop(),
            statusCount = _this2.analytics[status],
            caseSuffix = statusCount === 1 ? 'case' : 'cases';
        return (formattedStatus + ' (' + statusCount + ' ' + caseSuffix + ')').toUpperCase();
      }),
          statusCounts = usedStatuses.map(function (status) {
        return _this2.analytics[status];
      });

      return {
        datasets: [{
          backgroundColor: CHART_COLORS,
          data: statusCounts,
          hoverBackgroundColor: CHART_COLORS
        }],
        labels: statusLabels
      };
    }
  }]);

  return PerformanceAnalytics;
}(_react.Component), _class3.propTypes = {
  contact: _propTypes2.default.object,
  PartyStore: _propTypes2.default.object.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'isLoading', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'analytics', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'setInitialState', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'setInitialState'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = PerformanceAnalytics;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CASE_CLOSED_STATUSES, 'CASE_CLOSED_STATUSES', '/app/src/components/page-contacts/PerformanceAnalytics.js');
  reactHotLoader.register(CHART_COLORS, 'CHART_COLORS', '/app/src/components/page-contacts/PerformanceAnalytics.js');
  reactHotLoader.register(formatMoney, 'formatMoney', '/app/src/components/page-contacts/PerformanceAnalytics.js');
  reactHotLoader.register(formatPercentage, 'formatPercentage', '/app/src/components/page-contacts/PerformanceAnalytics.js');
  reactHotLoader.register(getNameOrDefault, 'getNameOrDefault', '/app/src/components/page-contacts/PerformanceAnalytics.js');
  reactHotLoader.register(CHART_OPTIONS, 'CHART_OPTIONS', '/app/src/components/page-contacts/PerformanceAnalytics.js');
  reactHotLoader.register(LEGEND_OPTIONS, 'LEGEND_OPTIONS', '/app/src/components/page-contacts/PerformanceAnalytics.js');
  reactHotLoader.register(PerformanceAnalytics, 'PerformanceAnalytics', '/app/src/components/page-contacts/PerformanceAnalytics.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-contacts/PerformanceAnalytics.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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